// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19w60","type":"styles_type__3CHa3","choices":"styles_choices__2Fu9G"};